/*
 * The temp state in redux is used for storing temporary data for a component.
 * Once the component is unmounted, this temp data should be cleared by invoking useEffect
 * with a cleanup function that dispatches CLEAR_TEMP action.
 */
export const INSERT_TEMP = '[temp] insert temporary data';
export const CLEAR_TEMP = '[temp] clear all temporary data';

export const insertTemp = (payload) => ({
  type: INSERT_TEMP,
  payload,
});

export const clearTemp = () => ({
  type: CLEAR_TEMP,
});
